/**
 * This file is the public access point. Everything other modules import should be available from index.js
 * The default export is what is needed to render the main component in Votify.
 */

import VotifySearchContainer from "./VotifySearchContainer";
import reducer, { STATE_KEY } from "./reducer";
import * as actions from "./actions";

export { reducer, STATE_KEY, actions };

export default VotifySearchContainer;
